// components/dashboard/DocumentRow.js

import React from "react";

const DocumentRow = ({ document, selectedDoc, onChange }) => (
	<div className="document-row">
		{onChange && 
			<input 
				type="radio" 
				name="document" 
				checked={document.id == selectedDoc?.id}
				value={selectedDoc?.id}
  				onChange={() => onChange(document)} 
			/>
		}
		<div className="document">
			<table className="w-full">
				<thead>
					<tr>
						<td className="date">Date</td>
						<td className="label">Libellé du document</td>
						<td>Montant HT</td>
						<td>TVA</td>
						<td>Montant TTC</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{document.displayable_operation_date}</td>
						<td className="flex flex-col">
							<span className="categ">{document.sub_category?.display_name}</span>
							<span>{document.label}</span>
						</td>
						<td>{document.amount} €</td>
						<td>{document.vat_value} € <span className="rate">({document.vat} %)</span></td>
						<td>{document.amount_with_vat} €</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
)

export default DocumentRow;
